import React from 'react';
import { createRoot } from 'react-dom/client';
import 'mobx-react-lite/batchingForReactDom';
import { initSentry } from './utils';
import App from './App';

initSentry();

const container = document.getElementById('root');
if (!container) throw new Error('Container not found');

const root = createRoot(container);

root.render(<App />);
